// Autogenerated by util/sync-labels/sync-labels.ts
// Do not edit this file directly.
// To regenerate this file, start ithriv_landing_service locally on port 8000 and
// run the following command in the root directory of the ithriv_web repository:
// > npm run sync_labels
import {LabelResponse} from '@backend';

export enum DatasetRole {
  ADMIN = 'admin',
  COLLABORATOR = 'collaborator',
  CUSTOMER = 'customer',
}

export const DatasetRoleLabels = {
  admin: 'Admin',
  collaborator: 'Collaborator',
  customer: 'Customer',
} as const;

export type DatasetRoleId = keyof typeof DatasetRoleLabels;
export type DatasetRoleLabel = (typeof DatasetRoleLabels)[DatasetRoleId];

export const DatasetRoleOptions: Record<DatasetRole, LabelResponse> = {
  admin: {
    id: DatasetRole.ADMIN,
    text: DatasetRoleLabels[DatasetRole.ADMIN],
    sensitivity_level_id: null,
    display_order: null,
  },
  collaborator: {
    id: DatasetRole.COLLABORATOR,
    text: DatasetRoleLabels[DatasetRole.COLLABORATOR],
    sensitivity_level_id: null,
    display_order: null,
  },
  customer: {
    id: DatasetRole.CUSTOMER,
    text: DatasetRoleLabels[DatasetRole.CUSTOMER],
    sensitivity_level_id: null,
    display_order: null,
  },
} as const;
